import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  showWizard: false,
  newClient: false,
  existingClient: false,
  quotationNumber : false
};

const wizardSlice = createSlice({
  name: "wizard",
  initialState,
  reducers: {
    setShowWizard: (state, action) => {
      state.showWizard = action.payload;
    },
     setNewClient: (state, action) => {
      state.newClient = action.payload;
    },
     setExisingClient: (state, action) => {
      state.existingClient = action.payload;
    },
    setquotationNumber: (state, action) => {
      state.quotationNumber = action.payload;
    },
  },
});

export const { setShowWizard, setNewClient, setExisingClient, setquotationNumber } = wizardSlice.actions;
export default wizardSlice.reducer;
